import { Action, CustomTagType, OperationType, Position, WindowType } from "puzzle";
import AdvancedSearchDialog from "../../components/SupplierView/AdvancedSearch/AdvancedSearchDialog";

export const openAdvancedSearchDialog: Action = [{
  moduleName: 'AdvancedSearchList',
  name: 'removeSavedSearchesSelection',
  type: OperationType.addOperationData
}, {
  name: 'initDataForAdvanceSearchDialog',
  type: OperationType.action
}, {
  children: [{
    render: AdvancedSearchDialog,
    propArgs: ['filterData', 'savedSearches', 'modeData'] //filterData is data needed for combo items, savedSearches are items on the left hand size on the dialog, and modeData are data for clone/edit
  }],
  className: 'lg abstract-filter-form advanced-search',
  items: [{
    btnName: 'AdvancedSearchDialog.clearAll',
    operations: [{
      moduleName: 'AdvancedSearchDialog',
      name: 'clearAllSearchData',
      type: OperationType.addOperationData
    }, {
      moduleName: 'AdvancedSearchDialog',
      name: 'getCustomFieldsActive',
      mappingName: 'customFieldsActive',
      type: OperationType.addOperationData
    }, {
      condition: '{customFieldsActive}',
      conditionOperations: [{
        moduleName: 'CustomFieldsFilter',
        name: 'resetFilter'
      }],
      type: OperationType.conditional
    }],
    btnConfig: {
      fillMode: 'outline',
      themeColor: 'primary',
      pos: Position.start,
      disabled: true
    },
    close: false
  }, {
    btnName: 'advancedSearchDialog.counter',
    operations: [],
    btnConfig: {
      customTagType: CustomTagType.counter,
      args: ['labelText', 'taskCount'],
      pos: Position.start
    }
  }, {
    operations: [],
    btnName: 'spacerEnd',
    btnConfig: {
      args: [''],
      customTagType: CustomTagType.label,
      pos: Position.end
    }
  }, {
    btnName: 'AdvancedSearchDialog.close',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
    close: false,
    operations: [{
      name: 'exitAdvancedSearchDialogWarning',
      type: OperationType.action
    }],
  }, {
    btnName: 'ESCAPE',
    close: false,
    operations: [{
      name: 'exitAdvancedSearchDialogWarning',
      type: OperationType.action
    }],
  }, {
    btnName: 'AdvancedSearchDialog.save',
    operations: [{
      moduleName: 'AdvancedSearchDialog',
      name: 'getCustomFieldsActive',
      mappingName: 'customFieldsActive',
      type: OperationType.addOperationData
    }, {
      condition: '{customFieldsActive}',
      conditionOperations: [{
        moduleName: 'CustomFieldsFilter',
        name: 'getCustomFiltersData',
        mappingName: 'customFiltersData',
        type: OperationType.addOperationData
      }],
      type: OperationType.conditional
    }, {
      moduleName: 'AdvancedSearchDialog',
      name: 'getData',
      args: ['customFiltersData'],
      mappingName: 'advancedSearchData',
      type: OperationType.addOperationData
    }, {
      moduleName: 'AdvancedSearchDialog',
      name: 'validateForm',
      mappingName: 'isAdvancedSearchValid',
      type: OperationType.addOperationData
    }, {
      condition: '{isAdvancedSearchValid}',
      conditionOperations: [{
        name: 'createAdvancedSearch',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }],
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    },
    close: false
  }, {
    btnName: 'AdvancedSearchDialog.search',
    operations: [{
      name: 'checkboxSelectionClear',
      type: OperationType.action
    }, {
      moduleName: 'AdvancedSearchDialog',
      name: 'getCustomFieldsActive',
      mappingName: 'customFieldsActive',
      type: OperationType.addOperationData
    }, {
      condition: '{customFieldsActive}',
      conditionOperations: [{
        moduleName: 'CustomFieldsFilter',
        name: 'getCustomFiltersData',
        mappingName: 'customFiltersData',
        type: OperationType.addOperationData
      }],
      type: OperationType.conditional
    }, {
      data: {
        template: {
          stringifyFormat: false
        }
      },
      moduleName: 'AdvancedSearchDialog',
      name: 'getData',
      args: ['customFiltersData', 'stringifyFormat'],
      mappingName: 'mainGridFilterData',
      type: OperationType.addOperationData
    }, {
      data: {
        template: {
          bind: {
            mainGridFilter: `_.get({mainGridFilterData},"filter")`,
            preserveSubmissionId: true
          }
        },
      },
      type: OperationType.data
    }, {
      moduleName: 'SearchBar',
      name: 'addFilterToState',
      args: ['mainGridFilter', 'preserveSubmissionId'],
      waitForModule: true,
      type: OperationType.addOperationData
    }, {
      name: 'filterMainGrid',
      type: OperationType.action
    }, {
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }],
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    },
    close: false
  }],
  title: 'AdvancedSearchDialog.title',
  type: OperationType.dialog
}]

export const exitAdvancedSearchDialogWarning: Action = [{
  moduleName: 'AdvancedSearchDialog',
  name: 'getFilterChangedValue',
  mappingName: 'filterChanged',
  type: OperationType.addOperationData
}, {
  condition: '{filterChanged}',
  conditionOperations: [{
    name: 'exitAdvancedSearchDialog.name',
    title: 'exitAdvancedSearchDialog.title',
    text: 'exitAdvancedSearchDialog.text',
    className: 'sm',
    items: [{
      btnName: 'common.cancel',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      },
      operations: []
    }, {
      btnName: 'common.exit',
      btnConfig: {
        pos: Position.end,
        themeColor: 'error'
      },
      operations: [{
        windowType: WindowType.dialog,
        type: OperationType.closeWindow
      }],
    }],
    type: OperationType.warning
  }],
  elseOperations: [{
    windowType: WindowType.dialog,
    type: OperationType.closeWindow
  }],
  type: OperationType.conditional
}];

export const updateAdvancedSearchDialogFooter: Action = [{
  buttons: [{
    name: 'AdvancedSearchDialog.clearAll',
    disabled: '{disabledClearAll}'
  }],
  customTags: [{
    name: 'advancedSearchDialog.counter',
    args: ['labelText', 'jobPhaseCount'],
  }],
  type: OperationType.updateDialog
}];

export const savedSearchWillBeChangedWarning: Action = [{
  persistent: ['nextItem'],
  type: OperationType.addPersistentData
}, {
  className: 'sm',
  items: [{
    btnName: 'switchSearch.cancel',
    operations: [{
      persistent: ['nextItem'],
      type: OperationType.removePersistentData
    }],
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    btnName: 'switchSearch.save',
    operations: [{
      moduleName: 'App',
      type: OperationType.maskModule
    }, {
      moduleName: 'AdvancedSearchDialog',
      name: 'getCustomFieldsActive',
      mappingName: 'customFieldsActive',
      type: OperationType.addOperationData
    }, {
      condition: '{customFieldsActive}',
      conditionOperations: [{
        moduleName: 'CustomFieldsFilter',
        name: 'getCustomFiltersData',
        mappingName: 'customFiltersData',
        type: OperationType.addOperationData
      }],
      type: OperationType.conditional
    }, {
      moduleName: 'AdvancedSearchDialog',
      name: 'getData',
      args: ['customFiltersData'],
      mappingName: 'advancedSearchData',
      type: OperationType.addOperationData
    }, {
      moduleName: 'AdvancedSearchDialog',
      name: 'validateForm',
      mappingName: 'isAdvancedSearchValid',
      type: OperationType.addOperationData
    }, {
      condition: '{isAdvancedSearchValid}',
      conditionOperations: [{
        data: {
          template: {
            bind: {
              params: '{advancedSearchData.filter}',
              method: '{advancedSearchData.method}',
              url: '{advancedSearchData.url}'
            }
          },
        },
        mappingName: 'saveFilterResponse',
        type: OperationType.request
      }, {
        name: 'loadAllSavedSearchList',
        type: OperationType.action
      }, {
        name: 'loadAdvancedSearchList',
        type: OperationType.action
      }, {
        moduleName: 'AdvancedSearchDialog',
        name: 'updateFormWithSelectedSearch',
        args: ['nextItem'],
        type: OperationType.addOperationData
      }],
      type: OperationType.conditional
    }, {
      persistent: ['nextItem'],
      type: OperationType.removePersistentData
    }, {
      moduleName: 'App',
      type: OperationType.unmaskModule
    }],
    btnConfig: {
      pos: Position.end,
      themeColor: 'primary'
    }
  }, {
    btnName: 'switchSearch.continue',
    operations: [{
      moduleName: 'AdvancedSearchDialog',
      name: 'updateFormWithSelectedSearch',
      args: ['nextItem'],
      type: OperationType.addOperationData
    }, {
      persistent: ['nextItem'],
      type: OperationType.removePersistentData
    }],
    btnConfig: {
      pos: Position.end,
      themeColor: 'error'
    }
  }],
  text: 'switchSearch.text',
  title: 'switchSearch.title',
  type: OperationType.dialog,
}]

export const loadAllSavedSearchList: Action = [{
  name: 'getAllSavedSearches',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        filters: '{savedSearches.filters}'
      }
    }
  },
  moduleName: 'AdvancedSearchDialog',
  name: 'updateFilters',
  args: ['filters'],
  type: OperationType.addOperationData
}]

export const initDataForAdvanceSearchDialog: Action = [{
  data: {
    labelText: 'advancedSearchDialog.selectedTasksInfo',
    taskCount: 0,
  },
  type: OperationType.data
}, {
  name: 'getAllSavedSearches',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        filterData: '{initializeUserData.searchBar}',
        savedSearches: '{savedSearches.filters}'
      }
    }
  },
  type: OperationType.data
}]

export const getAllSavedSearches: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  data: {
    url: `/jobPhase/filters`,
    method: 'get'
  },
  mappingName: 'savedSearches',
  type: OperationType.request
}];

export const deleteSavedSearchAndUpdateDialog: Action = [{
  data: {
    updateDialogSavedSearches: true
  },
  type: OperationType.data
}, {
  persistent: ['updateDialogSavedSearches'],
  type: OperationType.addPersistentData
}, {
  name: 'deleteSavedSearch',
  type: OperationType.action
}]

export const showHideSearch: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  data: {
    url: `/jobPhase/filters/updateFavoriteStatus`,
    method: 'put',
    template: {
      bind: {
        params: '{isFavoriteData}'
      }
    },
  },
  mappingName: 'saveFilterResponse',
  type: OperationType.request
}, {
  name: 'loadAdvancedSearchList',
  type: OperationType.action
}, {
  condition: '{updateDialogSavedSearches}',
  conditionOperations: [{
    name: 'getAllSavedSearches',
    type: OperationType.action
  }, {
    data: {
      template: {
        bind: {
          filters: '{savedSearches.filters}'
        }
      }
    },
    moduleName: 'AdvancedSearchDialog',
    name: 'updateFilters',
    args: ['filters'],
    type: OperationType.addOperationData
  }],
  type: OperationType.conditional
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}]

export const deleteSavedSearch: Action = [{
  persistent: ['filterIndex'],
  type: OperationType.addPersistentData
}, {
  className: 'sm confirm-light',
  items: [{
    btnName: 'deleteSearches.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
    operations: [{
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }, {
      persistent: ['filterIndex'],
      type: OperationType.removePersistentData
    }]
  }, {
    btnName: 'deleteSearches.yes',
    btnConfig: {
      themeColor: 'error',
      pos: Position.end
    },
    operations: [{
      moduleName: 'App',
      type: OperationType.maskModule
    }, {
      data: {
        template: {
          method: 'delete',
          bind: {
            url: '"/jobPhase/filters/delete/" + {filterIndex}',
          }
        }
      },
      type: OperationType.request
    }, {
      moduleName: 'App',
      localeProperty: 'deleteFilterConfirmationMsg',
      type: OperationType.maskModule
    }, {
      name: 'loadAdvancedSearchList',
      type: OperationType.action
    }, {
      condition: '{updateDialogSavedSearches}',
      conditionOperations: [{
        name: 'loadAllSavedSearchList',
        type: OperationType.action
      }, {
        persistent: ['updateDialogSavedSearches'],
        type: OperationType.removePersistentData
      }],
      type: OperationType.conditional
    }, {
      persistent: ['filterIndex'],
      type: OperationType.removePersistentData
    }, {
      moduleName: 'App',
      type: OperationType.unmaskModule
    }]
  }],
  text: 'deleteSearches.text',
  title: 'deleteSearches.title',
  type: OperationType.dialog
}];

export const saveEditedDataWarning: Action = [{
  persistent: ['advancedSearchData'],
  type: OperationType.addPersistentData
}, {
  className: 'sm',
  items: [{
    btnName: 'savedEditedFilter.cancel',
    operations: [{
      persistent: ['advancedSearchData'],
      type: OperationType.removePersistentData
    }],
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    btnName: 'savedEditedFilter.save',
    operations: [{
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }, {
      data: {
        template: {
          bind: {
            params: '{advancedSearchData.filter}',
            method: '{advancedSearchData.method}',
            url: '{advancedSearchData.url}'
          }
        },
      },
      mappingName: 'saveFilterResponse',
      type: OperationType.request
    }, {
      name: 'loadAdvancedSearchList',
      type: OperationType.action
    }, {
      persistent: ['advancedSearchData'],
      type: OperationType.removePersistentData
    }, {
      moduleName: 'App',
      type: OperationType.unmaskModule
    }],
    btnConfig: {
      pos: Position.end,
      themeColor: 'primary'
    }
  }],
  text: 'savedEditedFilter.text',
  title: 'savedEditedFilter.title',
  type: OperationType.dialog,
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}]

export const createAdvancedSearch: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  persistent: ['filterData'],
  type: OperationType.addPersistentData
}, {
  condition: '{advancedSearchData.method} === "put"',
  conditionOperations: [{
    name: 'saveEditedDataWarning',
    type: OperationType.action
  }],
  elseOperations: [{
    data: {
      template: {
        bind: {
          params: '{advancedSearchData.filter}',
          method: '{advancedSearchData.method}',
          url: '{advancedSearchData.url}'
        }
      },
    },
    mappingName: 'saveFilterResponse',
    type: OperationType.request
  }, {
    windowType: WindowType.dialog,
    type: OperationType.closeWindow
  }, {
    name: 'loadAdvancedSearchList',
    type: OperationType.action
  }, {
    moduleName: 'App',
    type: OperationType.unmaskModule
  }],
  type: OperationType.conditional
}]

export const loadAdvancedSearchList: Action = [{
  name: 'getVisibleSavedSearches',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        filters: '{savedSearches.filters}'
      }
    }
  },
  moduleName: 'AdvancedSearchList',
  name: 'loadSearchList',
  args: ['filters'],
  type: OperationType.addOperationData
}];

export const getVisibleSavedSearches: Action = [{
  data: {
    url: `/jobPhase/filters/favorite`,
    method: 'get'
  },
  mappingName: 'savedSearches',
  type: OperationType.request
}];

export const searchTaskListBySearchesClick: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  name: 'stopPingingRequestForFilterCount',
  type: OperationType.action
}, {
  moduleName: 'SearchBar',
  name: 'addFilterToState',
  args: ['filter'],
  waitForModule: true,
  type: OperationType.addOperationData
}, {
  moduleName: 'SearchBar',
  name: 'prepareDataForSearch',
  args: ['filter'],
  type: OperationType.addOperationData,
  mappingName: 'mainGridFilter'
}, {
  persistent: ['mainGridFilter'],
  type: OperationType.addPersistentData
}, {
  data: {
    template: {
      withRefresh: false
    }
  },
  moduleName: 'MainGrid',
  name: 'clearFilter',
  args: ['withRefresh']
}, {
  name: 'filterMainGrid',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}]

export const saveSearchesSort: Action = [{
  data: {
    url: '/jobPhase/filters/sortFilters',
    template: {
      bind: {
        params: '{params}'
      }
    },
  },
  type: OperationType.request
}, {
  name: 'loadAdvancedSearchList',
  type: OperationType.action
}];

export const getSearchBarDataAndUpdateDialog: Action = [{
  data: {
    template: {
      bind: {
        data: '{initializeUserData.searchBar}'
      }
    }
  },
  waitForModule: true,
  moduleName: 'AdvancedSearchDialog',
  name: 'loadFilterData',
  args: ['data']
}];

export const clearSearchFormAndGetProjectRelatedData: Action = [{
  name: 'clearSearchBarFilter',
  type: OperationType.action
}, {
  data: {
    method: 'post',
    url: '/filters/projectsInfo',
    template: {
      bind: {
        params: '{params}'
      }
    },
  },
  mappingName: 'filterDataResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        newFilterData: '{filterDataResponse.searchBar}'
      }
    }
  },
  moduleName: 'AdvancedSearchDialog',
  name: 'updateFilterData',
  args: ['newFilterData']
}];

export const updateSavedSearchesDialogFooter: Action = [{
  data: {
    labelText: 'advancedSearchDialog.selectedTasksInfo'
  },
  buttons: [],
  customTags: [{
    name: 'advancedSearchDialog.counter',
    args: ['labelText', 'jobPhaseCount'],
  }],
  type: OperationType.updateDialog,
}]

export const updateAdvancedSearchFooter: Action = [{
  data: {
    template: {
      bind: {
        jobPhaseCount: '{jobPhaseCount} || 0',
      }
    }
  },
  type: OperationType.data
}, {
  buttons: [{
    name: 'AdvancedSearchDialog.clearAll',
    disabled: '{disabledClearAll}'
  }],
  customTags: [{
    name: 'advancedSearchDialog.counter',
    args: ['labelText', 'jobPhaseCount'],
  }],
  type: OperationType.updateDialog
}]

export const getTaskCount: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  condition: '{customFieldsActive}',
  conditionOperations: [{
    waitForModule: true,
    moduleName: 'CustomFieldsFilter',
    name: 'appendCustomAttributesData',
    args: ['taskCountData'],
    mappingName: 'params',
    type: OperationType.addOperationData
  }],
  elseOperations: [{
    data: {
      template: {
        bind: {
          params: '{taskCountData}'
        }
      }
    },
    type: OperationType.data
  }],
  type: OperationType.conditional
}, {
  data: {
    url: '/jobPhase/filters/jobPhaseCount',
    template: {
      bind: {
        params: '{params}'
      }
    },
  },
  mappingName: 'jobPhaseCountResponse',
  type: OperationType.request
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}, {
  data: {
    template: {
      bind: {
        jobPhaseCount: '{jobPhaseCountResponse.jobPhaseCount} || 0',
        disabledClearAll: '{disabledClearAll}'
      }
    }
  },
  type: OperationType.data
}, {
  name: 'updateSavedSearchesDialogFooter',
  type: OperationType.action
}, {
  buttons: [{
    name: 'AdvancedSearchDialog.clearAll',
    disabled: '{disabledClearAll}'
  }],
  customTags: [{
    name: 'advancedSearchDialog.counter',
    args: ['labelText', 'jobPhaseCount'],
  }],
  type: OperationType.updateDialog
}, {
  moduleName: 'AdvancedSearchDialog',
  name: 'getFavoritesFilterCount'
}];

export const loadCustomFieldsValues = [{
  moduleName: 'CustomFieldsFilter',
  waitForModule: true,
  name: 'loadFiltersData',
  args: ['values']
}];

export const getCountAndLoadCustomFields = [{
  name: 'getTaskCount',
  type: OperationType.action
}, {
  condition: '{customFieldsActive}',
  conditionOperations: [{
    name: 'loadCustomFieldsValues',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const customFieldsFilterReset: Action = [{
  moduleName: 'CustomFieldsFilter',
  name: 'resetFilter'
}];